export default class vendorServicing_points {
  constructor() {
    this.currentPoints = $("#currentPoints");
    this.addRsTextField = $("#addRsTextField");
    this.addMoneyButton = $("#addMoneyButton");
    this.AddRsError = $("#AddRsError");
    this.ProceedtoAddAmount = $("#ProceedtoAddAmount");
    this.addAmount = $(".addAmount");
    this.ProceedtoAddAmountValue = $("#ProceedtoAddAmount")[0].innerHTML;

    this.vendorPointsFormID = $("#vendorPoints");

    this.bindEvents();
  }

  bindEvents = () => {
    this.getCurrentPoints();
    this.addMoneyButton.on("click", this.validateInputMoney);
    this.addAmount.on("click", this.addAmountFunction);
    this.addRsTextField.on("input", this.changeAmountonInput);

    //New Functions for cashFree
    $("#addMoneyButton").on("click", this.makeCashfreePayment);
    $(".vendorPaymentCheck").on("click", this.checkCashfreePayment);

    this.vendorPointsFormID.on("focus", "input[type=number]", function (e) {
      $(this).on("wheel.disableScroll", function (e) {
        //
        e.preventDefault();
      });
    });
  };

  getCurrentPoints = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/GetCurrentPoints",
      // data: {
      // },
      headers: { Authorization: X_API_KEY },
      success: this.showCurrentPoints,
    });
  };

  showCurrentPoints = (res) => {
    this.currentPoints.html(res[0].Vendor_Points);
  };
  changeAmountonInput = () => {
    let existingAmt = parseInt(this.addRsTextField.val());
    if (isNaN(existingAmt)) {
      this.addRsTextField.val(0);
    }
    let amountEntered = this.addRsTextField.val();
    this.ProceedtoAddAmount.html(amountEntered);
  };

  validateInputMoney = () => {
    if (this.addRsTextField.val() <= 0 || !this.addRsTextField.val()) {
      this.AddRsError.html("Enter Rs more than 0.");
    } else {
      this.AddRsError.html("");
    }
  };

  addAmountFunction = (e) => {
    let total = parseInt(this.addRsTextField.val()) + parseInt(e.target.value);

    this.addRsTextField.val(total);

    this.changeAmountonInput();
  };

  makeCashfreePayment = () => {
    var PaymentAmount = this.ProceedtoAddAmount[0].innerHTML;

    const dropConfig = {
      components: ["order-details", "card", "netbanking", "app", "upi"],
      onSuccess: this.cashfreePaymentSuccess,
      onFailure: this.cashfreePaymentFailure,
    };

    $.ajax({
      url: baseURL + "api/CashfreePayments/createOrder",
      type: "POST",
      data: {
        Vendor_ID: "null",
        Amount: PaymentAmount,
        Payment_Type: "Vendor Points",
        Picklist_ID: null,
      },
      success: (result) => {
        const responseObj = typeof result === "string" ? JSON.parse(result) : result;
        const paymentSessionId = responseObj["payment_session_id"];
        const mode = responseObj["environment"] || "production";
        
        const cashfree = Cashfree({
          mode: mode
        });
        
        cashfree.checkout({
          paymentSessionId: paymentSessionId,
          redirectTarget: "_self"
        });
      },
      error: (result) => {
        const errObj = typeof result === "string" ? JSON.parse(result) : result;
        console.error("Cashfree Order Creation Failed:", errObj);
      },
    });
  };

  cashfreePaymentSuccess = () => {};

  cashfreePaymentFailure = () => {};

  checkCashfreePayment = () => {
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    var payment_order_id = urlParams.get("payment_order_id");

    $.ajax({
      url: baseURL + "api/CashfreePayments/getOrder",
      type: "POST",
      data: {
        Payment_ID: payment_order_id,
      },
      success: (result) => {
        const responseObj = typeof result === "string" ? JSON.parse(result) : result;
        console.log("Payment status checked:", responseObj);
      },
      error: (result) => {
        const errObj = typeof result === "string" ? JSON.parse(result) : result;
        console.error("Payment status check failed:", errObj);
      },
    });
  };
}

